import React, { useState } from "react";
import { Button, Form, Input, message } from "antd";
import { IoSend } from "react-icons/io5";
import { FaAngleLeft, FaLock } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../services/apiConfig";

export default function PasswordInput({ otpData,userEmail }) {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleResetPassword = async (value) => {
    try {
      setLoading(true);
      const resp = await axios.post(`${API_BASE_URL}users/forgot-password/reset`, {
        reset_token: otpData,
        new_password: value.password,
      });

      if (resp.data?.success) {
        message.success(resp.data.message || "Password reset successfully");
        navigate("/account/sign-in");
      } else {
        message.error(resp.data?.message || "Unable to reset password");
      }
    } catch (error) {
      console.error(error);
      message.error(error?.response?.data?.message || "Unable to reset password, please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="inputCard">
      <h4>Reset Password</h4>
      <p>Step 3 of 3: Create a new password for your account.</p>
      <Form layout="vertical" onFinish={handleResetPassword} autoComplete="off">
        <Form.Item
          name="password"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input.Password
            prefix={<FaLock />}
            className="formInput"
            placeholder="Enter Password"
          />
        </Form.Item>
        <Form.Item
          name="confirmPassword"
          rules={[
            {
              required: true,
              message: "Please enter confirm password",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("The new password that you entered do not match!")
                );
              },
            }),
          ]}
        >
          <Input.Password
            prefix={<FaLock />}
            className="formInput"
            placeholder="Confirm Password"
          />
        </Form.Item>
        <Form.Item>
          <Button loading={loading} htmlType="submit" className="addButtons bg-dark text-white" icon={<IoSend />}>
            Reset Passwrod
          </Button>
        </Form.Item>
      </Form>
      <Link to="/account/sign-in">
        <FaAngleLeft /> Back to login page
      </Link>
    </div>
  );
}
